<template>
  <div class="sidearm-mm-tabs">
    <header class="flex flex-align-center flex-justify-between flex-wrap">
      <ul class="reset flex">
        <li v-for="(tab, tab_index) in tabs" :key="tab_index" class="mr-1">
          <button
            @click="change_active_tab(tab_index)"
            :class="{
              '--primary': value === tab_index,
              '--dashed --light': value !== tab_index
            }"
            type="button"
            class="sidearm-mm-btn"
          >
            {{ tab.name }}
          </button>
        </li>
      </ul>
      <slot name="header" />
    </header>

    <slot />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true,
      default: 0
    }
  },

  data: () => ({
    tabs: []
  }),

  watch: {
    value(newVal) {
      this.tabs = this.tabs.map((tab, index) => {
        if (index === newVal) {
          tab.is_active = true;
        } else {
          tab.is_active = false;
        }

        return tab;
      });
    }
  },

  methods: {
    change_active_tab(tab_index = 0) {
      this.$emit("input", tab_index);
    }
  },

  created() {
    this.tabs = this.$children;

    this.$nextTick(() => {
      this.tabs[this.value].is_active = true;
    });
  }
};
</script>

<style lang="scss" scoped>
.sidearm-mm-tabs {
  .sidearm-mm-btn {
    padding: $spacer * 1.5 $spacer * 3;
  }
}
</style>
